// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608110934/js/" + chunkId + "." + {"44":"97c3924e","225":"dd00f927","481":"e324cb7d","486":"d4d428ef","770":"d57b91fa"}[chunkId] + ".0.9446868017802236.chunk.js";
};